<div class="side-nav">
  <nav class="sidebar">
    <div class="heading">
      <div class="sidebar-header">
        <app-orca-logo
          [logoWidthRem]="4"
          [logoHeightRem]="4"/>
      </div>
      @if (isDemo) {
        <div style="display: flex;align-items: center;justify-items: center; font-weight: bold;">
          <span>Demo</span>
        </div>
      }
    </div>

    <div class="flex flex-col items-center content-center h-full">
      <div
        data-qa="sidenav-organization"
        class="flex flex-col items-center content-center side-nav-menu-item opacity0p5 not-clickable">
        <app-all-icons [iconNameAndStyling]="'case-bag.svg; icon-size-1p875 white-12'"></app-all-icons>
        <span>Organization</span>
      </div>

      <div
        data-qa="sidenav-fund"
        class="flex flex-col items-center content-center side-nav-menu-item opacity0p5 not-clickable">
        <app-all-icons [iconNameAndStyling]="'fund.svg; icon-size-1p875 white-12'"></app-all-icons>
        <span>Fund</span>
      </div>

      <div
        data-qa="sidenav-investors"
        class="flex flex-col items-center justify-center side-nav-menu-item opacity0p5 not-clickable">
        <app-all-icons [iconNameAndStyling]="'organization.svg; icon-size-1p875 white-12'"></app-all-icons>
        <span>Investors</span>
      </div>

      <div
        data-qa="sidenav-prediction-models"
        class="flex flex-col items-center content-center side-nav-menu-item bg-main-8">
        <app-all-icons [iconNameAndStyling]="'prediction-models.svg; icon-size-1p875 white-12'"></app-all-icons>
        <span>Prediction models</span>
      </div>

      <div
         data-qa="sidenav-investor-report"
         class="flex flex-col items-center content-center side-nav-menu-item opacity0p5 not-clickable">
        <app-all-icons [iconNameAndStyling]="'paper-plane.svg; white-12 icon-size-1p875'"></app-all-icons>
        <span>Reports</span>
      </div>

      <div
        data-qa="sidenav-switch-software"
        (click)="navigateToEntrance()"
        class="last-item flex flex-col items-center content-center side-nav-menu-item">
        <app-all-icons [iconNameAndStyling]="'other-services.svg; white-12 icon-size-1p875'"></app-all-icons>
      </div>
    </div>
  </nav>
</div>

